import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/announcements").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); } catch { return ""; } };

  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-3 mb-5">
        <Megaphone size={30} className="text-[#E60000]" />
        <h1 className="font-heading font-black uppercase text-3xl text-[#F0EDEA]">Announcements</h1>
      </div>
      {loading ? (
        <div className="text-[#A8A2A0] text-center py-16">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-[#A8A2A0] text-center py-16" data-testid="no-announcements">No announcements yet.</div>
      ) : (
        <div className="space-y-5">
          {items.map((a) => (
            <article key={a.id} className="bg-[#1C1C1C] border border-[#333] rounded-2xl overflow-hidden" data-testid={`announcement-${a.id}`}>
              {a.media && (
                a.media.kind === "video"
                  ? <video src={mediaUrl(a.media)} className="w-full max-h-80 object-cover" controls playsInline />
                  : <img src={mediaUrl(a.media)} className="w-full max-h-80 object-cover" alt="" />
              )}
              <div className="p-5">
                <div className="text-[#A8A2A0] text-xs mb-1">{fmt(a.created_at)}</div>
                <h2 className="font-heading font-bold uppercase text-xl text-[#F0EDEA]">{a.title}</h2>
                {a.text && <p className="text-[#A8A2A0] text-sm mt-2 whitespace-pre-line">{a.text}</p>}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
